import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import { useLanguage } from '../LanguageContext';
import './ForgotPassword.css';

export default function ForgotPassword() {
  const { language } = useLanguage();
  const text = language === 'zh' ? {
    title: '🔐 忘记密码',
    desc: '输入你的注册邮箱，我们会发送密码重置链接。',
    email: '邮箱地址',
    invalidEmail: '请输入有效的邮箱地址',
    failed: '请求提交失败，请稍后再试',
    sending: '发送中...',
    submit: '发送重置链接',
    successTitle: '请查收邮箱！',
    successText: mail => `如果 ${mail} 已注册，我们已发送密码重置链接。`,
    note: '请打开邮件中的链接，自己设置新密码。',
    back: '返回登录',
  } : {
    title: '🔐 Forgot password',
    desc: 'Enter your registered email and we will send a password reset link.',
    email: 'Email address',
    invalidEmail: 'Please enter a valid email address',
    failed: 'Request failed. Please try again later.',
    sending: 'Sending...',
    submit: 'Send reset link',
    successTitle: 'Check your email',
    successText: mail => `If ${mail} is registered, we have sent a password reset link.`,
    note: 'Open the link in your email to set a new password yourself.',
    back: 'Back to login',
  };
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.includes('@')) {
      setError(text.invalidEmail);
      return;
    }
    setLoading(true);
    try {
      await api.post('/users/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || text.failed);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fpw-page">
      <div className="fpw-card">
        <h1>{text.title}</h1>

        {!sent ? (
          <>
            <p className="fpw-desc">{text.desc}</p>
            <form onSubmit={onSubmit}>
              <label>{text.email}</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
              />
              {error && <div className="fpw-err">{error}</div>}
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? text.sending : text.submit}
              </button>
            </form>
          </>
        ) : (
          <div className="fpw-success">
            <div className="fpw-check">✓</div>
            <h3>{text.successTitle}</h3>
            <p>{text.successText(email)}</p>
            <p className="fpw-note">{text.note}</p>
          </div>
        )}

        <div className="fpw-footer">
          <Link to="/login">← {text.back}</Link>
        </div>
      </div>
    </div>
  );
}
